export * from './ubiFilter.service';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/services/ubiFilter/index.ts